"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredAcademies = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const DiscardCards_1 = require("../../deferredActions/DiscardCards");
const CardRenderer_1 = require("../render/CardRenderer");
const DrawCards_1 = require("../../deferredActions/DrawCards");
const Card_1 = require("../Card");
class SponsoredAcademies extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.SPONSORED_ACADEMIES,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SCIENCE],
            cost: 9,
            metadata: {
                cardNumber: '247',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().cards(1).br;
                    b.plus().cards(3).digit.asterix().nbsp().plus().cards(1).any.asterix();
                }),
                description: 'Discard 1 card from your hand and THEN draw 3 cards. All OPPONENTS draw 1 card.',
                victoryPoints: 1,
            },
        });
    }
    ;
    canPlay(player) {
        return player.cardsInHand.length > 1;
    }
    play(player) {
        player.game.defer(new DiscardCards_1.DiscardCards(player), DeferredAction_1.Priority.SPONSORED_ACADEMIES);
        player.game.defer(DrawCards_1.DrawCards.keepAll(player, 3), DeferredAction_1.Priority.SPONSORED_ACADEMIES);
        const otherPlayers = player.game.getPlayers().filter((p) => p.id !== player.id);
        for (const p of otherPlayers) {
            player.game.defer(DrawCards_1.DrawCards.keepAll(p));
        }
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.SponsoredAcademies = SponsoredAcademies;
//# sourceMappingURL=SponsoredAcademies.js.map